import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
  selector: 'button-cmp',
  templateUrl: './button.component.html',
})
export class ButtonComponent implements OnInit {
  @Input() isLogin: string = 'false';
  @Input() isAdd: string = 'false';
  @Input() isCancel: string = 'false';
  @Input() isOk: string = 'false';
  @Input() isDelete: string = 'false';
  @Input() isNormal: string = 'false';
  @Input() title: string = '';
  constructor() {}

  ngOnInit(): void {

  }
}
